import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, signal, ViewEncapsulation } from '@angular/core';
import { FourYearLossHistoryFormGroup, LossDetailsRecord } from './FourYearLossHistoryFormGroup';
import { MessageService } from 'primeng/api';
import { dropDownOptions } from 'src/app/modal/DAO';
import { LossHistoryConstants } from 'src/app/modal/LossHistoryConstants.models';
import { UntypedFormGroup } from '@angular/forms';
import { Constants } from 'src/app/modal/ProjConstants.models';

@Component({
  selector: 'four-year-loss-history',
  templateUrl: './four-year-loss-history-form.component.html',
  styleUrls: ['./four-year-loss-history.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class FourYearLossHistoryComponent implements OnInit, OnDestroy {
  @Input() fourYearLossHistoryFormGroup: FourYearLossHistoryFormGroup;
  @Input() isSubmitted: boolean = false;
  @Output() resetLastFourYearsLosses: EventEmitter<boolean> = new EventEmitter();

  public isAddEditButtonClicked: boolean = false;
  public lossHistoryPriorCarrier: Array<dropDownOptions> = LossHistoryConstants.LossHistoryPriorCarrier;
  public typeOfLoss: Array<dropDownOptions> = LossHistoryConstants.TypeOfLosses;
  public typeOfLossStatus: Array<dropDownOptions> = LossHistoryConstants.TypeOfLossStatus;
  public maxDate: Date = new Date();
  public menuItems: any[] = [
    {
      label: 'Edit',
      icon: 'pi pi-pencil',
      command: () => this.editSelectedRow()
    },
    {
      label: 'Duplicate',
      icon: 'pi pi-copy',
      command: () => this.duplicateSelectedRow()
    },
    {
      label: 'Delete',
      icon: 'pi pi-trash',
      command: () => this.deleteSelectedRow()
    }
  ];

  constructor(private messageService: MessageService) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.fourYearLossHistoryFormGroup.resetLossFormGroup(); 
  }

  public validateAndAddLossesHistory(): void {
    this.isAddEditButtonClicked = true;
    if (this.fourYearLossHistoryFormGroup.valid) {
         this.fourYearLossHistoryFormGroup.moveNewLossToArray();
         this.isAddEditButtonClicked = false;
         this.shallDiplayDialog.set(false);
    } else {
      this.displayRequiredMessage();
    }
  }

  public validateAndUpdateLossHistory(rowIndex: number, lossRowInEdit: LossDetailsRecord, currentFG: UntypedFormGroup): void {
    this.isAddEditButtonClicked = true;
    if (currentFG.valid) {
        this.fourYearLossHistoryFormGroup.setValuesToList(rowIndex);
        this.isAddEditButtonClicked = false;
        lossRowInEdit.isEdit = false;
    } else {
      this.displayRequiredMessage();
    }
  }

  public deleteLossHistory(rowIndex: number): void {
    this.fourYearLossHistoryFormGroup.deleteLoss(rowIndex);
  }

  private displayRequiredMessage() {
    this.messageService.add({ key: 'RequiredMsg', severity: 'error', summary: 'Loss History #', detail: Constants.PLS_UPDATE_FIELDS_IN_RED });
  }

  openMenu(event: Event, index: number, menu: any): void {
    this.fourYearLossHistoryFormGroup.selectedRowIndex = index;
    menu.toggle(event);
  }

  private duplicateSelectedRow(): void {
        this.fourYearLossHistoryFormGroup.duplicateLossHistory();
        this.shallDiplayDialog.set(true);
  }

  private editSelectedRow(): void {
    if (this.fourYearLossHistoryFormGroup.selectedRowIndex !== null) {
      this.fourYearLossHistoryFormGroup.populateNewLossFormGroupFromSelectedRow();
      this.shallDiplayDialog.set(true);
    }
  }

  private deleteSelectedRow(): void {
    if (this.fourYearLossHistoryFormGroup.selectedRowIndex !== null) {
      this.deleteLossHistory(this.fourYearLossHistoryFormGroup.selectedRowIndex);
    }
  }
 
  public shallDiplayDialog = signal(false);

  public popUpDialogForAddLoss(): void {
    this.fourYearLossHistoryFormGroup.resetLossFormGroup();
    this.shallDiplayDialog.set(true);
  }

  public onDialogClose(visible: boolean): void {
    this.shallDiplayDialog.set(visible);
    if (!visible) {
      this.fourYearLossHistoryFormGroup.resetLossFormGroup();
      this.isAddEditButtonClicked = false;
    }
  }

  public SubmitAddedOrUpdatedLoss(): void {
    this.isAddEditButtonClicked = true;
    const newLossFormGroup = this.fourYearLossHistoryFormGroup.get('newLossFormGroup') as UntypedFormGroup;
    if (newLossFormGroup.valid) {
      if (this.fourYearLossHistoryFormGroup.selectedRowIndex !== null) {
        // Update existing row
        this.fourYearLossHistoryFormGroup.updateLossFromDialog(this.fourYearLossHistoryFormGroup.selectedRowIndex);
      } else {
        // Add new row
        this.fourYearLossHistoryFormGroup.moveNewLossToArray();
      }
      this.isAddEditButtonClicked = false;
      this.shallDiplayDialog.set(false);
    } else {
      this.displayRequiredMessage();
    }
  }
}